module.exports = __webpack_public_path__ + "static/media/App.9bd0f5f0.scss";


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = ./src/App.scss
// module chunks = 0